import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useOnboardingStatus } from './OnboardingStatusContext';

/**
 * Requires an authenticated, **approved** doctor. Onboarding status is cached in
 * {@link OnboardingStatusContext} to avoid refetching on every protected navigation.
 */
export const ApprovedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoading: authLoading, isAuthenticated } = useAuth();
  const { loading, redirectTo } = useOnboardingStatus();

  if (authLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--zivo-color-text-muted)',
        }}
      >
        Loading…
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--zivo-color-text-muted)',
        }}
      >
        Checking account status...
      </div>
    );
  }
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};
